
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SpinalAnesthesia",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/SpinalAnesthesia.vue